import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Carousel() {
  return (
    <div className="container con1">
      <h1>Life At NLF</h1>
      <div className="container con2">
        <div id="demo" className="carousel slide" data-bs-ride="carousel">
      
          <div className="slider-inner">
            <div className="carousel-item slide2 active">
              
              <img src="career-img/Design-lab.png" alt="Los Angeles" className="d-block  img-fluid" />
              <div className="carousel-caption  d-md-block innerSliderText">
                <h5>Design Lab Days</h5>
                <p>  At NLF, we believe great spaces are built by great people.<br/>
  At NLF, creativity isn’t confined to the drawing board. Our monthly Design Lab Days give teams the space to experiment, prototype, and pitch new ideas—be it a sustainable furniture concept, a modular interior layout, or a bold brand revamp. It’s innovation in motion, powered by people.

                        </p>
              </div>
            </div>
            <div className="carousel-item slide2">
              <img src="career-img/dialogue.jpg" alt="Chicago" className="d-block  img-fluid" />
              <div className="carousel-caption  d-md-block innerSliderText">
                <h5>Design Dialogues</h5>
                <p>
                         Weekly design sessions and cross-team meetups<br/>
  fuel our passion for innovation. These dialogues are<br/>
  more than meetings—they’re where bold ideas<br/>
  take root, evolve, and shape the spaces we create.
                        </p>
              </div>
            </div>
            <div className="carousel-item slide2">
              <img src="career-img/breaks.jpg" alt="New York" className="d-block  img-fluid" />
              <div className="carousel-caption  d-md-block innerSliderText">
                <h5>Creative Breaks & Celebrations</h5>
                <p>
                          From studio lunches to birthday surprises and<br/>
  festive décor contests, we celebrate milestones<br/>
  and moments alike. NLF’s culture values joy<br/>
  as much as discipline—it’s all part of the process.
                        </p>
              </div>
            </div>
            <div className="carousel-item slide2">
              <img src="career-img/outing.webp" alt="outings image" className="d-block  img-fluid" />
              <div className="carousel-caption  d-md-block innerSliderText">
                <h5>Team Outings & Inspiration Tours</h5>
                <p>
                         We step out of the office to refuel our imagination.<br/>
  Whether it’s nature retreats or material expos,<br/>
  our outings are designed to spark fresh thinking,<br/>
  deepen bonds, and bring new perspectives to work
                        </p>
              </div>
            </div>
          </div>
        </div>
        <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#demo"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#demo"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
      </div>
    </div>
  );
}

export default Carousel;
